import React from 'react'
import createPrimaryUserInCompanyMutation from 'graphs/mutations/createPrimaryUserInCompany.graphql'
import CompanyPrimaryUser from 'graphs/queries/CompanyPrimaryUser.graphql'
import userValidation from 'validations/user'
import FormForRecord from 'components/FormForRecord'
import userFields from 'fields/users'

const RouteCompaniesUsersNew = ({
  match: { url },
  history: { goBack },
  company,
  ...rest
}) => (
  <FormForRecord
    mutation={createPrimaryUserInCompanyMutation}
    onSuccess={goBack}
    onCancel={goBack}
    fields={userFields}
    variables={{ company_id: company.id }}
    schema={userValidation}
    title={`Create A Primary User for ${company.name}`}
    mutationArgs={{
      update: (store, { data }) => {
        try {
          const result = store.readQuery({
            query: CompanyPrimaryUser,
            variables: { company_id: company.id }
          })
          result.company.primary_user = data.createPrimaryUserInCompany
          store.writeQuery({
            query: CompanyPrimaryUser,
            variables: { company_id: company.id },
            data: result
          })
        } catch (e) {} // readQuery throws if no record
      }
    }}
    {...rest}
  />
)

export default RouteCompaniesUsersNew



// WEBPACK FOOTER //
// ./src/routes/admin/companies/primary_user/new.js